import {
  call, put, delay,
} from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  checkStatusRollbackVersionSuccessful, checkStatusRollbackVersionFailed,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { BACKEND_URL_V2 } from '../../../configs';
import { OK } from '../../../configs/serverStatusCodes';

export default function* checkStatusRollbackVersion(action) {
  try {
    const url = `${BACKEND_URL_V2}/audit/rollback-plans/${action?.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true, true);
    const data = yield dataResponse.json();
    if (dataResponse?.status === OK) {
      yield put(checkStatusRollbackVersionSuccessful(data?.data));
      yield call(resolveActionPromise(action, data?.data));
    } else {
      yield put(checkStatusRollbackVersionFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(checkStatusRollbackVersionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
